import gql from "graphql-tag"
import partialUser from "@irati/identity/services/fragments/PartialUser"

const fragment = gql`
  fragment Recognition on Recognition {
    uuid
    createdAt
    message
    source
    walletTransferId
    moderated
    private
    receivers {
      results {
        ...partialUser
      }
    }
    teams {
      results {
        uuid
        public_name
      }
    }
    createdBy {
      ...partialUser
    }
    reward {
      desc
      alt
      href
      id
      legacy
    }
    rewardOrder {
      costPerUnit {
        amount
        currency
      }
      reward {
        header
      }
      rewardId
      custom
      createdBy {
        ...partialUser
      }
      recipients {
        results {
          ...partialUser
        }
      }
    }
    reactions {
      results {
        reaction
      }
    }
    comments {
      results {
        uuid
        createdAt
        updatedAt
        createdBy {
          ...partialUser
        }
        message
        moderated
        archived
        reactions {
          results {
            createdAt
            createdBy {
              ...partialUser
            }
            reaction
            uuid
          }
        }
      }
    }
    occasion {
      uuid
      name
      default
      icon {
        href
        alt
      }
      archived
    }
    companyValues {
      results {
        archived
        name
        tag
        uuid
      }
    }
  }
  ${partialUser}
`

export default fragment
